<template>
    <div>
        <div class="px-5 sm:px-20 mt-10 pt-5" :class="{'!p-0 !mt-0': isModal}">
            <div class="font-medium text-base">
            ข้อมูลทั่วไป
            </div>
            <div
            class="grid grid-cols-12 gap-4 gap-y-5 mt-5 items-baseline"
            data-test="profile-form"
            >
                <div class="col-span-12">
                    <div class="grid grid-cols-12 gap-4 gap-y-5">
                        <div class="col-span-12 sm:col-span-6 ">
                            <div>
                                <label
                                    for="form-input-name"
                                    class="form-label"
                                >ชื่อ<span class="text-red"> *</span></label>
                                <div class="flex">
                                    <div class="mr-1 h-full w-48">
                                        <!-- <treeselect data-test="prefix-name" v-model="validate.title.$model" :multiple="false" :searchable="false" :options="formOption.prefixOption" placeholder="คำนำหน้าชื่อ" :class="{ 'border-1 border-theme-24 rounded-md': validate.title.$error }">
                                            <label slot="option-label" slot-scope="{ node }">
                                                {{ node.label }}
                                            </label>
                                        </treeselect> -->
                                        <v-select
                                            data-test="prefix-name"
                                            id="prefix-name"
                                            v-model="validate.title.$model"
                                            :options="formOption.prefixOption"
                                            label="label"
                                            :reduce="label => label.id"
                                            :clearable="false"
                                            :searchable="false"
                                            placeholder="คำนำหน้าชื่อ"
                                            :class="{ 'border-1 border-theme-24 rounded-md': validate.title.$error }"
                                        >
                                            <template #open-indicator="{ attributes }">
                                                <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                                            </template>
                                        </v-select>
                                        <template v-if="validate.title.$error">
                                            <div
                                            v-for="(error, index) in validate.title.$errors"
                                            :key="index"
                                            class="text-theme-24 mt-1 text-xs"
                                            >
                                            {{ error.$message }}
                                            </div>
                                        </template>
                                    </div>
                                    <div class="w-full">
                                        <input
                                            id="form-input-name"
                                            type="text"
                                            class="form-control"
                                            placeholder="กรุณากรอกชื่อ"
                                            data-test="first-name"
                                            v-model="form.name"
                                            v-model.trim="validate.name.$model"
                                            :class="{ 'border-theme-24': validate.name.$error }"
                                        >
                                        <template v-if="validate.name.$error">
                                            <div
                                            v-for="(error, index) in validate.name.$errors"
                                            :key="index"
                                            class="text-theme-24 mt-1 text-xs"
                                            >
                                            {{ error.$message }}
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-5">
                                <label
                                    for="form-input-last-name"
                                    class="form-label"
                                >นามสกุล<span class="text-red"> *</span></label>
                                <input
                                    id="form-input-last-name"
                                    type="text"
                                    class="form-control"
                                    placeholder="กรุณากรอกนามสกุล"
                                    data-test="last-name"
                                    v-model="form.surname"
                                    v-model.trim="validate.surname.$model"
                                    :class="{ 'border-theme-24': validate.surname.$error }"
                                >
                                <template v-if="validate.surname.$error">
                                    <div
                                    v-for="(error, index) in validate.surname.$errors"
                                    :key="index"
                                    class="text-theme-24 mt-1 text-xs"
                                    >
                                    {{ error.$message }}
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="col-span-12 sm:col-span-6 row-span-2 order-first sm:order-last">
                            <div class="">
                                <label
                                    for="form-input-profile-image"
                                    class="form-label"
                                >ภาพประจำตัว</label>
                                <div
                                    class="image-upload m-auto sm:m-0"
                                    id="form-input-profile-image"
                                >
                                    <div class="absolute w-full h-full preview-image">
                                        <img v-if="imagePreview" :src="imagePreview" class="w-full h-full"/>
                                    </div>
                                    <div class="w-full h-full">
                                        <ImageIcon class="opacity-30 w-20 h-20 icon-img" />
                                        <label>
                                            <input
                                                type="file"
                                                class="image-file"
                                                data-test="image-upload"
                                                @change="uploadImage"
                                                @click="$event.target.value=null"
                                                accept="image/*"
                                            >
                                        </label>
                                    </div>
                                </div>
                                <!-- <template v-if="validate.imageFile.$error">
                                    <div
                                    v-for="(error, index) in validate.imageFile.$errors"
                                    :key="index"
                                    class="text-theme-24 mt-1 text-xs"
                                    >
                                    {{ error.$message }}
                                    </div>
                                </template> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-span-12">
                    <div class="grid grid-cols-12 gap-4 gap-y-5">
                        <div class="col-span-12 sm:col-span-6">
                            <label
                            class="form-label"
                            >สัญชาติ<span class="text-red"> *</span></label>
                            <RadioCustomButton
                                class="w-40"
                                name="nation-radio-group"
                                first-option-id="form-input-nation-th"
                                second-option-id="form-input-nation-oth"
                                :first-option-value="formOption.nationOption[0].text"
                                :second-option-value="formOption.nationOption[1].text"
                                v-model="validate.nationality.$model"
                                :class="{ 'border-theme-24': validate.nationality.$error }"
                                :isDisabled="form.is_hh_head == 1 || form.is_fam_head == 1 || !isModal"
                            />
                            <template v-if="validate.nationality.$error">
                                <div
                                v-for="(error, index) in validate.nationality.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                                >
                                {{ error.$message }}
                                </div>
                            </template>
                        </div>
                        <div class="col-span-12 sm:col-span-6" v-if="form.nationality == 'ไทย'">
                            <label
                            for="form-input-citizen-id"
                            class="form-label"
                            >เลขบัตรประจำตัวประชาชน<span class="text-red"> *</span></label>
                            <input
                            id="form-input-citizen-id"
                            type="text"
                            class="form-control"
                            placeholder="กรุณากรอกเลขบัตรประจำตัวประชาชน"
                            data-test="citizen-id"
                            v-model="form.national_id"
                            v-model.trim="validate.national_id.$model"
                            :class="{ 'border-theme-24': validate.national_id.$error || validate.national_id.$invalid || checkPersonIDCard == false || isNotUniqueIDCard == false}"
                            :state="checkPersonIDCard && isNotUniqueIDCard"
                            oninput="if(this.value.length > 13){this.value = this.value.slice(0, 13);}"
                            @input="checkExistIdcard"
                            :readonly="IDcardChecking"
                            >
                            <template v-if="validate.national_id.$error || validate.national_id.$invalid">
                                <div class="text-theme-24 mt-1 text-xs"
                                >
                                {{validate.national_id.required.$message}}
                                </div>
                            </template>
                            <template v-if="checkPersonIDCard == false">
                                <div
                                class="text-theme-24 mt-1 text-xs"
                                >
                                รูปแบบข้อมูลไม่ถูกต้อง
                                </div>
                            </template>
                            <template v-if="isNotUniqueIDCard == false">
                                <div
                                class="text-theme-24 mt-1 text-xs whitespace-pre-line"
                                >
                                ไม่สามารถเพิ่มสมาชิกด้วยเลขบัตรประชาชนนี้ได้ เนื่องจากพบข้อมูลของบุคคลนี้ที่
                                {{duplicateDataChecked.village_name? `หมู่บ้าน${duplicateDataChecked.village_name}`:''}}
                                {{duplicateDataChecked.tumbol_name ? `ตำบล${duplicateDataChecked.tumbol_name}` : ''}}
                                {{duplicateDataChecked.amphur_name? `อำเภอ${duplicateDataChecked.amphur_name}`:''}}
                                {{duplicateDataChecked.province_name?`จังหวัด${duplicateDataChecked.province_name}`:''}}
                                {{`\nผู้รับผิดชอบ: `}}{{duplicateDataChecked.case_manager?.uid ? `${duplicateDataChecked.case_manager.uid} (${duplicateDataChecked.case_manager.title} ${duplicateDataChecked.case_manager.name} ${duplicateDataChecked.case_manager.surname})` : '-'}}
                                </div>
                            </template>
                        </div>
                        <div class="col-span-12 sm:col-span-6" v-if="form.nationality == 'อื่นๆ'">
                            <label
                            for="form-input-citizen-id"
                            class="form-label"
                            >สัญชาติ</label>
                            <input
                            id="form-input-citizen-id"
                            type="text"
                            class="form-control"
                            placeholder="กรุณากรอกสัญชาติ"
                            data-test="citizen-id"
                            v-model="form.nationality_other"
                            >
                        </div>
                    </div>
                </div>
                <div class="col-span-12">
                    <div class="grid grid-cols-12 gap-4 gap-y-5">
                        <div class="col-span-12 sm:col-span-6">
                            <label
                            class="form-label"
                            >เพศ<span class="text-red"> *</span></label>
                            <RadioCustomButton
                                class="w-40"
                                name="gender-radio-group"
                                first-option-id="form-input-gender-m"
                                second-option-id="form-input-gender-f"
                                first-option-value="ชาย"
                                second-option-value="หญิง"
                                v-model="validate.sex.$model"
                                :class="{ 'border-theme-24': validate.sex.$error }"
                            />
                            <template v-if="validate.sex.$error">
                                <div
                                v-for="(error, index) in validate.sex.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                                >
                                {{ error.$message }}
                                </div>
                            </template>
                        </div>
                        <div class="col-span-12 sm:col-span-6">
                            <label
                            class="form-label"
                            >วัน/เดือน/ปีเกิด<span class="text-red"> *</span></label>
                            <div class="relative">
                                <!-- <div
                                    class="absolute rounded-l w-10 h-full flex items-center justify-center bg-gray-100 border text-gray-600 dark:bg-dark-1 dark:border-dark-4"
                                >
                                    <CalendarIcon class="w-4 h-4" />
                                </div> 
                                <Litepicker
                                    v-model="validate.birthdate.$model"
                                    :options="{
                                        format: 'DD-MM-YYYY',
                                        autoApply: false,
                                        showWeekNumbers: true,
                                        dropdowns: {
                                            minYear: 1990,
                                            maxYear: null,
                                            months: true,
                                            years: true,
                                            resetButton: true
                                        }
                                    }"
                                    class="form-control pl-12"
                                    data-test="birth-date"
                                    :class="{ 'border-theme-24': validate.birthdate.$error }"
                                /> -->
                                <Datepicker 
                                    v-model="validate.birthdate.$model" data-test="birth-date"
                                    :inputClassName="validate.birthdate.$error ? 'border-theme-24': ''"
                                    :enableTimePicker="false"
                                    :monthChangeOnScroll="false"
                                    selectText="ตกลง"
                                    cancelText="ยกเลิก"
                                    locale="th"
                                    :month-year-component="monthYear"
                                    :format="format"
                                    :previewFormat="format"
                                    :maxDate="new Date()"
                                    preventMinMaxNavigation
                                    :yearRange="[1900, new Date().getFullYear()]"
                                ></Datepicker>
                                <!-- <DatePicker v-model="form.birthdate"></DatePicker> -->
                            </div>
                             <template v-if="validate.birthdate.$error">
                                    <div
                                    v-for="(error, index) in validate.birthdate.$errors"
                                    :key="index"
                                    class="text-theme-24 mt-1 text-xs"
                                    >
                                    {{ error.$message }}
                                    </div>
                                </template>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-span-12">
                    <div class="grid grid-cols-12 gap-4 gap-y-5">
                        <div class="col-span-12 sm:col-span-6">
                            <label
                            class="form-label"
                            >การเป็นหัวหน้าครัวเรือน<span class="text-red"> *</span></label>
                            <RadioCustomButton
                                class="w-40"
                                name="household-radio-group"
                                first-option-id="form-input-household-yes"
                                second-option-id="form-input-household-no"
                                :first-option-value="formOption.choiceOption[0].value"
                                :second-option-value="formOption.choiceOption[1].value"
                                :first-option-text="formOption.choiceOption[0].text"
                                :second-option-text="formOption.choiceOption[1].text"
                                v-model="validate.is_hh_head.$model"
                                :class="{ 'border-theme-24': validate.is_hh_head.$error }"
                            />
                            <template v-if="validate.is_hh_head.$error">
                                <div
                                v-for="(error, index) in validate.is_hh_head.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                                >
                                {{ error.$message }}
                                </div>
                            </template>
                        </div>
                        <div class="col-span-12 sm:col-span-6" v-if="form.is_hh_head == 0">
                            <label
                            class="form-label"
                            >ความเกี่ยวข้องกับหัวหน้าครัวเรือน</label>
                            <treeselect data-test="household-relation" v-model="validate.hh_head_relation.$model" :multiple="false" :searchable="false" :options="formOption.relationOption" placeholder="ความเกี่ยวข้องกับหัวหน้าครัวเรือน" :class="{ 'border-1 border-theme-24 rounded-md': validate.hh_head_relation.$error ||  validate.hh_head_relation.$invalid}">
                                <label slot="option-label" slot-scope="{ node }">
                                    {{ node.label }}
                                </label>
                            </treeselect>
                            <template v-if="validate.hh_head_relation.$error || validate.hh_head_relation.$invalid">
                                <div class="text-theme-24 mt-1 text-xs"
                                >
                                {{validate.hh_head_relation.required.$message}}
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-span-12">
                    <div class="grid grid-cols-12 gap-4 gap-y-5">
                        <div class="col-span-12 sm:col-span-6">
                            <label
                            class="form-label"
                            >การเป็นหัวหน้าครอบครัว<span class="text-red"> *</span></label>
                            <RadioCustomButton
                                class="w-40"
                                name="family-radio-group"
                                first-option-id="form-input-family-yes"
                                second-option-id="form-input-family-no"
                                :first-option-value="formOption.choiceOption[0].value"
                                :second-option-value="formOption.choiceOption[1].value"
                                :first-option-text="formOption.choiceOption[0].text"
                                :second-option-text="formOption.choiceOption[1].text"
                                v-model="validate.is_fam_head.$model"
                                :class="{ 'border-theme-24': validate.is_fam_head.$error }"
                            />
                            <template v-if="validate.is_fam_head.$error">
                                <div
                                v-for="(error, index) in validate.is_fam_head.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                                >
                                {{ error.$message }}
                                </div>
                            </template>
                        </div>
                        <div class="col-span-12 sm:col-span-6" v-if="form.is_fam_head == 0">
                            <label
                            class="form-label"
                            >ความเกี่ยวข้องกับหัวหน้าครอบครัว</label>
                            <treeselect data-test="family-relation" v-model="validate.fam_head_relation.$model" :multiple="false" :searchable="false" :options="formOption.relationOption" placeholder="ความเกี่ยวข้องกับหัวหน้าครอบครัว" :class="{ 'border-1 border-theme-24 rounded-md': validate.fam_head_relation.$error || validate.fam_head_relation.$invalid }">
                                <label slot="option-label" slot-scope="{ node }">
                                    {{ node.label }}
                                </label>
                            </treeselect>
                            <template v-if="validate.fam_head_relation.$error || validate.fam_head_relation.$invalid">
                                <div class="text-theme-24 mt-1 text-xs"
                                >
                                {{validate.fam_head_relation.required.$message}}
                                </div>
                            </template>
                        </div>
                    </div>
                </div> -->
                <div class="col-span-12">
                    <div class="grid grid-cols-12 gap-4 gap-y-5">
                        <div class="col-span-12 sm:col-span-6">
                            <label
                            class="form-label"
                            >สถานะการมีชีวิต<span class="text-red"> *</span></label>
                            <RadioCustomButton
                                class="w-40"
                                name="status-radio-group"
                                first-option-id="form-input-status-yes"
                                second-option-id="form-input-status-no"
                                :first-option-value="formOption.livingStatusOption[0].value"
                                :second-option-value="formOption.livingStatusOption[1].value"
                                :first-option-text="formOption.livingStatusOption[0].text"
                                :second-option-text="formOption.livingStatusOption[1].text"
                                v-model="validate.vital_status.$model"
                                :class="{ 'border-theme-24': validate.vital_status.$error }"
                            />
                            <template v-if="validate.vital_status.$error">
                                <div
                                v-for="(error, index) in validate.vital_status.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                                >
                                {{ error.$message }}
                                </div>
                            </template>
                        </div>
                        <div class="col-span-12 sm:col-span-6" v-if="form.vital_status == 1">
                            <label
                            class="form-label"
                            >สถานะการสมรส<span class="text-red"> *</span></label>
                            <!-- <treeselect data-test="marital-status" v-model="validate.marital_status.$model" :multiple="false" :searchable="false" :options="formOption.maritalStatusOption" placeholder="สถานะ" :class="{ 'border-1 border-theme-24 rounded-md': validate.marital_status.$error || validate.marital_status.$invalid }">
                                <label slot="option-label" slot-scope="{ node }">
                                    {{ node.label }}
                                </label>
                            </treeselect> -->
                            <v-select
                                data-test="marital-status"
                                v-model="validate.marital_status.$model"
                                :options="formOption.maritalStatusOption"
                                :clearable="false"
                                :searchable="false"
                                placeholder="สถานะ"
                                :class="{ 'border-1 border-theme-24 rounded-md': validate.marital_status.$error || validate.marital_status.$invalid }"
                                label="label"
                                :reduce="label => label.id"
                            >
                                <template #open-indicator="{ attributes }">
                                    <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                                </template>
                            </v-select>
                            <template v-if="validate.marital_status.$error || validate.marital_status.$invalid">
                                <div class="text-theme-24 mt-1 text-xs"
                                >
                                {{validate.marital_status.required.$message}}
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-span-12 sm:col-span-6">
                    <label
                    class="form-label"
                    >ศาสนา<span class="text-red"> *</span></label>
                    <!-- <treeselect :value="form.religion" data-test="religion" v-model="validate.religion.$model" :multiple="false" :searchable="false" :options="formOption.religionOption" placeholder="ศาสนา" :class="{ 'border-1 border-theme-24 rounded-md': validate.religion.$error }">
                        <label slot="option-label" slot-scope="{ node }">
                            {{ node.label }}
                        </label>
                    </treeselect> -->
                    <v-select
                        :clearable="false"
                        data-test="religion"
                        v-model="validate.religion.$model"
                        :searchable="false"
                        :options="formOption.religionOption"
                        placeholder="ศาสนา"
                        :class="{ 'border-1 border-theme-24 rounded-md': validate.religion.$error }"
                        label="label"
                        :reduce="label => label.id"
                    >
                        <template #open-indicator="{ attributes }">
                            <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                        </template>
                    </v-select>
                    <template v-if="validate.religion.$error">
                        <div
                        v-for="(error, index) in validate.religion.$errors"
                        :key="index"
                        class="text-theme-24 mt-1 text-xs"
                        >
                        {{ error.$message }}
                        </div>
                    </template>
                </div>
                <div class="col-span-12 sm:col-span-6">
                    <label
                    class="form-label"
                    >เบอร์โทรศัพท์</label>
                    <input
                    type="text"
                    class="form-control"
                    placeholder="กรุณากรอกเบอร์โทรศัพท์"
                    data-test="phone-number"
                    v-model="form.mobile_num"
                    @input="onlyNumber"
                    >
                </div>
                <div class="font-medium text-base col-span-12">
                    ข้อมูลบิดา
                </div>
                <div class="col-span-12 sm:col-span-6 ">
                    <label
                    class="form-label"
                    >ชื่อ<span class="text-red"> *</span></label>
                    <div class="flex">
                        <div class="mr-1 h-full w-48">
                            <!-- <treeselect data-test="father-prefix-name" v-model="validate.father.title.$model" :multiple="false" :searchable="false" :options="formOption.prefixOption" placeholder="คำนำหน้าชื่อ" :class="{ 'border-1 border-theme-24 rounded-md': validate.father.title.$error }">
                                <label slot="option-label" slot-scope="{ node }">
                                    {{ node.label }}
                                </label>
                            </treeselect> -->
                            <v-select
                                :clearable="false"
                                data-test="father-prefix-name"
                                v-model="validate.father.title.$model"
                                :searchable="false"
                                :options="formOption.prefixOption"
                                placeholder="คำนำหน้าชื่อ"
                                :class="{ 'border-1 border-theme-24 rounded-md': validate.father.title.$error }"
                                label="label"
                                :reduce="label => label.id"
                            >
                                <template #open-indicator="{ attributes }">
                                    <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                                </template>
                            </v-select>
                            <template v-if="validate.father.title.$error">
                                <div
                                v-for="(error, index) in validate.father.title.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                                >
                                {{ error.$message }}
                                </div>
                            </template>
                        </div>
                        <div class="w-full">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="กรุณากรอกชื่อ"
                                data-test="father-first-name"
                                v-model="form.father.name"
                                v-model.trim="validate.father.name.$model"
                                :class="{ 'border-theme-24': validate.father.name.$error }"
                            >
                            <template v-if="validate.father.name.$error">
                                <div
                                v-for="(error, index) in validate.father.name.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                                >
                                {{ error.$message }}
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-span-12 sm:col-span-6">
                    <label
                    class="form-label"
                    >นามสกุล<span class="text-red"> *</span></label>
                    <input
                    type="text"
                    class="form-control"
                    placeholder="กรุณากรอกนามสกุล"
                    data-test="father-last-name"
                    v-model="form.father.surname"
                    v-model.trim="validate.father.surname.$model"
                    :class="{ 'border-theme-24': validate.father.surname.$error }"
                    >
                    <template v-if="validate.father.surname.$error">
                        <div
                        v-for="(error, index) in validate.father.surname.$errors"
                        :key="index"
                        class="text-theme-24 mt-1 text-xs"
                        >
                        {{ error.$message }}
                        </div>
                    </template>
                </div>
                <div class="col-span-12 sm:col-span-6">
                    <label
                    class="form-label"
                    >สัญชาติ<span class="text-red"> *</span></label>
                    <RadioCustomButton
                        class="w-40"
                        name="father-nationality-radio-group"
                        first-option-id="form-input-father-nation-th"
                        second-option-id="form-input-father-nation-oth"
                        :first-option-value="formOption.nationOption[0].text"
                        :second-option-value="formOption.nationOption[1].text"
                        v-model="validate.father.nationality.$model"
                        :class="{ 'border-theme-24': validate.father.nationality.$error }"
                    />
                    <template v-if="validate.father.nationality.$error">
                        <div
                        v-for="(error, index) in validate.father.nationality.$errors"
                        :key="index"
                        class="text-theme-24 mt-1 text-xs"
                        >
                        {{ error.$message }}
                        </div>
                    </template>
                </div>
                <div class="col-span-12 sm:col-span-6" v-if="form.father.nationality == 'ไทย'">
                    <label
                    class="form-label"
                    >เลขบัตรประจำตัวประชาชน</label>
                    <input
                    type="text"
                    class="form-control"
                    placeholder="กรุณากรอกเลขบัตรประจำตัวประชาชน"
                    data-test="father-citizen-id"
                    v-model="form.father.national_id"
                    :class="{ 'border-theme-24': checkFatherIDCard == false }"
                    @input="inputNumber"
                    :state="checkFatherIDCard"
                    oninput="if(this.value.length > 13){this.value = this.value.slice(0, 13);}"
                    >
                    <!-- <template v-if="validate.father.national_id.$error || validate.father.national_id.$invalid">
                        <div class="text-theme-24 mt-1 text-xs"
                        >
                        {{validate.father.national_id.required.$message}}
                        </div>
                    </template> -->
                    <template v-if="checkFatherIDCard == false">
                        <div
                        class="text-theme-24 mt-1 text-xs"
                        >
                        รูปแบบข้อมูลไม่ถูกต้อง
                        </div>
                    </template>
                </div>
                <div class="col-span-12 sm:col-span-6" v-if="form.father.nationality == 'อื่นๆ'">
                    <label
                    class="form-label"
                    >สัญชาติ</label>
                    <input
                    type="text"
                    class="form-control"
                    placeholder="กรุณากรอกสัญชาติ"
                    data-test="father-citizen-id"
                    v-model="form.father.nationality_other"
                    >
                </div>
                <div class="col-span-12 sm:col-span-6">
                    <label
                    class="form-label"
                    >สถานะการมีชีวิต<span class="text-red"> *</span></label>
                    <RadioCustomButton
                        class="w-40"
                        name="status-father-living-radio-group"
                        first-option-id="form-father-living-yes"
                        second-option-id="form-father-living-no"
                        :first-option-value="formOption.livingStatusOption[0].value"
                        :second-option-value="formOption.livingStatusOption[1].value"
                        :first-option-text="formOption.livingStatusOption[0].text"
                        :second-option-text="formOption.livingStatusOption[1].text"
                        v-model="validate.father.vital_status.$model"
                        :class="{ 'border-theme-24': validate.father.vital_status.$error }"
                    />
                    <template v-if="validate.father.vital_status.$error">
                        <div
                        v-for="(error, index) in validate.father.vital_status.$errors"
                        :key="index"
                        class="text-theme-24 mt-1 text-xs"
                        >
                        {{ error.$message }}
                        </div>
                    </template>
                </div>
                <hr class="col-span-12">
                <div class="font-medium text-base col-span-12">
                    ข้อมูลมารดา
                </div>
                <div class="col-span-12 sm:col-span-6 ">
                    <label
                    class="form-label"
                    >ชื่อ<span class="text-red"> *</span></label>
                    <div class="flex">
                        <div class="mr-1 h-full w-48">
                            <!-- <treeselect data-test="mother-prefix-name" v-model="validate.mother.title.$model" :multiple="false" :searchable="false" :options="formOption.prefixOption" placeholder="คำนำหน้าชื่อ" :class="{ 'border-1 border-theme-24 rounded-md': validate.mother.title.$error }">
                                <label slot="option-label" slot-scope="{ node }">
                                    {{ node.label }}
                                </label>
                            </treeselect> -->
                            <v-select
                                :clearable="false"
                                data-test="mother-prefix-name"
                                v-model="validate.mother.title.$model"
                                :searchable="false"
                                :options="formOption.prefixOption"
                                placeholder="คำนำหน้าชื่อ"
                                :class="{ 'border-1 border-theme-24 rounded-md': validate.mother.title.$error }"
                                label="label"
                                :reduce="label => label.id"
                            >
                                <template #open-indicator="{ attributes }">
                                    <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                                </template>
                            </v-select>
                            <template v-if="validate.mother.title.$error">
                                <div
                                v-for="(error, index) in validate.mother.title.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                                >
                                {{ error.$message }}
                                </div>
                            </template>
                        </div>
                        <div class="w-full">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="กรุณากรอกชื่อ"
                                data-test="mother-first-name"
                                v-model="form.mother.name"
                                v-model.trim="validate.mother.name.$model"
                                :class="{ 'border-theme-24': validate.mother.name.$error }"

                            >
                            <template v-if="validate.mother.name.$error">
                                <div
                                v-for="(error, index) in validate.mother.name.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                                >
                                {{ error.$message }}
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-span-12 sm:col-span-6">
                    <label
                    class="form-label"
                    >นามสกุล<span class="text-red"> *</span></label>
                    <input
                    type="text"
                    class="form-control"
                    placeholder="กรุณากรอกนามสกุล"
                    data-test="mother-last-name"
                    v-model="form.mother.surname"
                    v-model.trim="validate.mother.surname.$model"
                    :class="{ 'border-theme-24': validate.mother.surname.$error }"
                    >
                    <template v-if="validate.mother.surname.$error">
                        <div
                        v-for="(error, index) in validate.mother.surname.$errors"
                        :key="index"
                        class="text-theme-24 mt-1 text-xs"
                        >
                        {{ error.$message }}
                        </div>
                    </template>
                </div>
                <div class="col-span-12 sm:col-span-6">
                    <label
                    class="form-label"
                    >สัญชาติ<span class="text-red"> *</span></label>
                    <RadioCustomButton
                        class="w-40"
                        name="mother-nationality-radio-group"
                        first-option-id="form-input-mother-nation-th"
                        second-option-id="form-input-mother-nation-oth"
                        :first-option-value="formOption.nationOption[0].text"
                        :second-option-value="formOption.nationOption[1].text"
                        v-model="validate.mother.nationality.$model"
                        :class="{ 'border-theme-24': validate.mother.nationality.$error }"
                    />
                    <template v-if="validate.mother.nationality.$error">
                        <div
                        v-for="(error, index) in validate.mother.nationality.$errors"
                        :key="index"
                        class="text-theme-24 mt-1 text-xs"
                        >
                        {{ error.$message }}
                        </div>
                    </template>
                </div>
                <div class="col-span-12 sm:col-span-6" v-if="form.mother.nationality == 'ไทย'">
                    <label
                    for="form-input-mother-cid"
                    class="form-label"
                    >เลขบัตรประจำตัวประชาชน</label>
                    <input
                    id="form-input-mother-cid"
                    type="text"
                    class="form-control"
                    placeholder="กรุณากรอกเลขบัตรประจำตัวประชาชน"
                    data-test="mother-citizen-id"
                    v-model="form.mother.national_id"
                    :class="{ 'border-theme-24': checkMotherIDCard == false }"
                    :state="checkMotherIDCard"
                    @input="inputNumber"
                    oninput="if(this.value.length > 13){this.value = this.value.slice(0, 13);}"
                    >
                    <!-- <template v-if="validate.mother.national_id.$error || validate.mother.national_id.$invalid">
                        <div class="text-theme-24 mt-1 text-xs"
                        >
                        {{validate.mother.national_id.required.$message}}
                        </div>
                    </template> -->
                    <template v-if="checkMotherIDCard == false">
                        <div
                        class="text-theme-24 mt-1 text-xs"
                        >
                        รูปแบบข้อมูลไม่ถูกต้อง
                        </div>
                    </template>
                </div>
                <div class="col-span-12 sm:col-span-6" v-if="form.mother.nationality == 'อื่นๆ'">
                    <label
                    for="form-input-mother-cid"
                    class="form-label"
                    >สัญชาติ</label>
                    <input
                    id="form-input-mother-cid"
                    type="text"
                    class="form-control"
                    placeholder="กรุณากรอกสัญชาติ"
                    data-test="mother-citizen-id"
                    v-model="form.mother.nationality_other"
                    >
                </div>
                <div class="col-span-12 sm:col-span-6">
                    <label
                    class="form-label"
                    >สถานะการมีชีวิต<span class="text-red"> *</span></label>
                    <RadioCustomButton
                        class="w-40"
                        name="status-mother-living-radio-group"
                        first-option-id="form-mother-living-yes"
                        second-option-id="form-mother-living-no"
                        :first-option-value="formOption.livingStatusOption[0].value"
                        :second-option-value="formOption.livingStatusOption[1].value"
                        :first-option-text="formOption.livingStatusOption[0].text"
                        :second-option-text="formOption.livingStatusOption[1].text"
                        v-model="validate.mother.vital_status.$model"
                        :class="{ 'border-theme-24': validate.mother.vital_status.$error }"
                    />
                    <template v-if="validate.mother.vital_status.$error">
                        <div
                        v-for="(error, index) in validate.mother.vital_status.$errors"
                        :key="index"
                        class="text-theme-24 mt-1 text-xs"
                        >
                        {{ error.$message }}
                        </div>
                    </template>
                </div>
                <hr class="col-span-12">
                <div class="font-medium text-base col-span-12">
                    การศึกษา
                </div>
                <label
                    class="form-label col-span-12"
                >สถานะการศึกษา<span class="text-red"> *</span></label>
                <div class="col-span-12">
                    <div class="grid grid-cols-12 gap-4 gap-y-5" :class="{ 'border-1 border-theme-24 rounded-md p-2': validate.edu_status.$error }">
                        <div class="col-span-12 sm:col-span-4 md:col-span-3" v-for="(edu,key) in dataJson.education" :key="key">
                            <div class="mr-2 mt-2 sm:mt-0 form-check-input-indent">
                            <input
                                :id="`form-input-edu-${edu.option.code}`"
                                class="form-check-input align-middle"
                                type="radio"
                                v-model="validate.edu_status.$model"
                                :value="edu.option"
                            >
                            <label
                                class="form-check-label align-middle"
                                :for="`form-input-edu-${edu.option.code}`"
                            >{{edu.option.desc}}</label>
                            </div>
                        </div>
                    </div>
                    <template v-if="validate.edu_status.$error">
                        <div
                        v-for="(error, index) in validate.edu_status.$errors"
                        :key="index"
                        class="text-theme-24 mt-1 text-xs"
                        >
                        {{ error.$message }}
                        </div>
                    </template>
                </div>
                <label
                    class="form-label col-span-12"
                >ระดับการศึกษาสูงสุด<span class="text-red"> *</span></label>
                <div class="col-span-12">
                    <div class="grid grid-cols-12 gap-4 gap-y-5" :class="{ 'border-1 border-theme-24 rounded-md p-2': validate.edu_level.$error }">
                        <div class="col-span-12 sm:col-span-4 md:col-span-3" v-for="(edu,key) in dataJson.education_level" :key="key">
                            <div class="mr-2 mt-2 sm:mt-0 form-check-input-indent">
                            <input
                                :id="`form-input-edu-${edu.option.code}`"
                                class="form-check-input align-middle"
                                type="radio"
                                v-model="validate.edu_level.$model"
                                :value="edu.option"
                            >
                            <label
                                class="form-check-label align-middle"
                                :for="`form-input-edu-${edu.option.code}`"
                            >{{edu.option.desc}}</label>
                            </div>
                        </div>
                    </div>
                    <template v-if="validate.edu_level.$error">
                        <div
                        v-for="(error, index) in validate.edu_level.$errors"
                        :key="index"
                        class="text-theme-24 mt-1 text-xs"
                        >
                        {{ error.$message }}
                        </div>
                    </template>
                </div>
                <label
                    class="form-label col-span-12"
                >การเข้าร่วมกลุ่มกิจกรรมของชุมชน<span class="text-red"> *</span></label>
                <div class="col-span-12">
                    <div class="grid grid-cols-12 gap-4 gap-y-5" :class="{ 'border-1 border-theme-24 rounded-md p-2': validate.attend_socact.$error }">
                        <div class="col-span-12 sm:col-span-4 md:col-span-3" v-for="(social,key) in dataJson.attend_social" :key="key">
                            <div class="form-checkbox-custom pl-6">
                                <div class="mr-3">
                                    <label
                                        class="form-check-label align-middle"
                                        :for="`form-input-social-${social.option.code}`"
                                    >
                                        <input
                                            :id="`form-input-social-${social.option.code}`"
                                            class="form-check-input align-middle"
                                            type="checkbox"
                                            v-model="form.attend_socact"
                                            :value="social.option"
                                            @change="validate.attend_socact.$touch()"
                                        >
                                        {{social.option.desc}}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <template v-if="validate.attend_socact.$error">
                        <div
                        v-for="(error, index) in validate.attend_socact.$errors"
                        :key="index"
                        class="text-theme-24 mt-1 text-xs"
                        >
                        {{ error.$message }}
                        </div>
                    </template>
                </div>
                <hr class="col-span-12" v-show="form.csg?.register_status || form.csg?.status || form.csg?.registrant_type == 'ผู้ปกครอง'">
                <div class="font-medium text-base col-span-12" v-show="form.csg?.register_status || form.csg?.status || form.csg?.registrant_type == 'ผู้ปกครอง'">
                    ข้อมูลเด็กแรกเกิด (ดึงอัตโนมัติจากระบบ CSG)
                </div>
                <div class="col-span-12 sm:col-span-6" v-show="form.csg?.registrant_type == 'ผู้ปกครอง'">
                <label class="form-label">
                    สถานะผู้ลงทะเบียน<span class="text-red"> *</span>:
                    <span class="ml-2 font-normal"> {{form.csg?.registrant_type || '-'}}
                    </span>
                </label>
                </div>
                                <div class="col-span-12 sm:col-span-6" v-show="form.csg?.status">
                <label class="form-label">
                    สถานะเด็ก<span class="text-red"> *</span>:
                    <span class="ml-2 font-normal"> {{form.csg?.status || '-'}}
                    </span>
                </label>
                </div>
                <!-- <div class="col-span-12 sm:col-span-6" v-show="form.parent?.national_id && form.csg?.registrant_type == 'ผู้ปกครอง'">
                <label class="form-label">
                    บัตรประชาชน (ผู้ปกครอง)<span class="text-red"> *</span>:
                    <span class="ml-2 font-normal"> {{form.parent?.national_id || '-'}}
                    </span>
                </label>
                </div> -->
                <div class="col-span-12 sm:col-span-6" v-show="form.parent?.name && form.csg?.registrant_type == 'ผู้ปกครอง'">
                <label class="form-label">
                    ชื่อ-นามสกุล (ผู้ปกครอง)<span class="text-red"> *</span>:
                    <span class="ml-2 font-normal"> {{ form.parent?.name ? `${form.parent.title || ''} ${form.parent.name} ${form.parent.surname || ''}` : '-' }}
                    </span>
                </label>
                </div>
                                <!-- <div class="col-span-12 sm:col-span-6" v-show="form.parent?.birthdate && form.csg?.registrant_type == 'ผู้ปกครอง'">
                <label class="form-label">
                    วัน/เดือน/ปีเกิด (ผู้ปกครอง)<span class="text-red"> *</span>:
                    <span class="ml-2 font-normal"> {{form.parent?.birthdate || '-'}}
                    </span>
                </label>
                </div> -->
                                <!-- <div class="col-span-12 sm:col-span-6" v-show="form.parent?.nationality && form.csg?.registrant_type == 'ผู้ปกครอง'">
                <label class="form-label">
                     สัญชาติ (ผู้ปกครอง)<span class="text-red"> *</span>:
                    <span class="ml-2 font-normal"> {{form.parent?.nationality || '-'}}
                    </span>
                </label>
                </div> -->
                                <div class="col-span-12 sm:col-span-6" v-show="form.csg?.register_status">
                <label class="form-label">
                    สถานะลงทะเบียน<span class="text-red"> *</span>:
                    <span class="ml-2 font-normal"> {{form.csg?.register_status || '-'}}
                    </span>
                </label>
                </div>
            </div>
            <hr class="col-span-12 mt-10">
        </div>
        <!-- footer -->
        <div
        class="col-span-12 flex items-center mt-10 justify-end"
        v-if="isModal"
        >
            <div>
                <button
                class="btn btn-outline-secondary"
                data-dismiss="modal"
                @click="cancelModalButton"
                >
                ยกเลิก
                </button>
                <button
                class="btn btn-primary ml-2"
                @click="nextStep"
                >
                บันทึก
                </button>
            </div>
        </div>
        <div
        class="col-span-12 flex items-center mt-10 px-5 sm:px-20 justify-between"
        v-else
        >
            <div>
                <button
                class="btn btn-secondary"
                @click="closeWizardForm"
                >
                ออก
                </button>
                <!-- <button
                class="btn btn-secondary ml-2"
                @click="skipStep"
                >
                ข้าม
                </button> -->
            </div>
            <div>
                <button
                class="btn btn-primary ml-2"
                @click="nextStep"
                >
                บันทึกและถัดไป
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { ref,  defineComponent, reactive, watch, toRefs, computed, defineAsyncComponent} from 'vue'
import dataJson from "@/data/general.json"
import RadioCustomButton from "@/components/base/radio-custom-button/index.vue";
import useVuelidate from '@vuelidate/core'
import { required, helpers, requiredIf } from '@vuelidate/validators'
// import Treeselect from 'vue3-treeselect'
// import 'vue3-treeselect/dist/vue3-treeselect.css'
import Swal from 'sweetalert2'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import {useRoute,useRouter} from "vue-router"
import axios from "axios"
import { useStore } from 'vuex';
import { checkDuplicateIdcard } from "../container/checkIdCard"
import { uploadfile } from "@/utils/minio.js";
var md5 = require('md5');

const MonthYear = defineAsyncComponent(() => import('../../custom-datepicker/monthComponent.vue'));

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})

export default defineComponent({
    props:{
        isModal:{
            type: Boolean,
            default: false
        },
        formSearch:{
            type: Object
        },
        updateId:{
            type: String
        },
        editData:{
            type: Object
        },
        cancelModal:{
            type: Boolean,
            default: false
        },
        openModal:{
            type: Boolean,
            default: false
        }
    },
    components:{
        RadioCustomButton,
        Datepicker
    },
    setup(props,{emit}){
const router = useRouter();
        const monthYear = computed(() => MonthYear);
        const format = (date) => {
            const day = ("0" + date.getDate()).slice(-2);
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const year = date.getFullYear() + 543;

            return `${day}/${month}/${year}`;
        }
        const convertThaiDateToISO = (thaiDate) => {
  const [day, month, yearBE] = thaiDate.split('-');
  
  const yearCE = parseInt(yearBE) - 543;

  const date = new Date(yearCE, parseInt(month) - 1, day);
  return date.toISOString(); 
}
        const formOption = reactive({
            prefixOption:[
                {id: "นาย", label: "นาย"},
                {id: "นาง", label: "นาง"},
                {id: "นางสาว", label: "นางสาว"},
                {id: "เด็กหญิง", label: "เด็กหญิง"},
                {id: "เด็กชาย", label: "เด็กชาย"}
            ],
            nationOption:[
                {text:"ไทย"},
                {text:"อื่นๆ"}
            ],
            choiceOption: [
                {text:"เป็น", value: 1},
                {text:"ไม่เป็น", value: 0}
            ],
            livingStatusOption: [
                {text: "มีชีวิตอยู่", value: 1},
                {text: "เสียชีวิต", value: 0}
            ],
            genderOption:[
                {text:"ชาย"},
                {text:"หญิง"}
            ],
            relationOption:[
                {id:"คู่สมรส", label:"คู่สมรส"},
                {id:"บิดา/มารดา", label:"บิดา/มารดา"},
                {id:"บุตร", label:"บุตร"},
                {id:"ญาติพี่น้อง", label:"ญาติพี่น้อง"},
                {id:"ผู้อาศัย", label:"ผู้อาศัย"},
            ],
            religionOption:[
                {id:"พุทธ", label:"พุทธ"},
                {id:"คริสต์", label:"คริสต์"},
                {id:"อิสลาม", label:"อิสลาม"},
                {id:"พราหมณ์-ฮินดู", label:"พราหมณ์-ฮินดู"},
                {id:"ซิกข์", label:"ซิกข์"},
            ],
            maritalStatusOption:[
                {id: "โสด", label: "โสด"},
                {id: "สมรส", label: "สมรส"},
                {id: "หม้าย", label: "หม้าย"},
                {id: "หย่า", label: "หย่า"},
                {id: "แยกกันอยู่", label: "แยกกันอยู่"},
                {id: "สมรสไม่จดทะเบียน", label: "สมรสไม่จดทะเบียน"}
            ],
        })
        const form = reactive({
            title: null,
            name: null,
            surname: null,
            nationality: null,
            sex: null,
            national_id: null,
            is_hh_head: null,
            is_fam_head: null,
            fam_head_relation: null,
            hh_head_relation: null,
            religion: null,
            vital_status: null,
            marital_status: null,
            father:{},
            mother:{},
            edu_status: null,
            edu_level: null,
            attend_socact:[],
            imageFile: null,
            tempImage: null,
            birthdate: null,
            mobile_num: null,
            nationality_other: null,
            image:{}
        })
        const formDefault = reactive({
            title: null,
            name: null,
            surname: null,
            nationality: null,
            sex: null,
            national_id: null,
            is_hh_head: null,
            is_fam_head: null,
            fam_head_relation: null,
            hh_head_relation: null,
            religion: null,
            vital_status: null,
            marital_status: null,
            father:{},
            mother:{},
            edu_status: null,
            edu_level: null,
            attend_socact:[],
            imageFile: null,
            tempImage: null,
            birthdate: null,
            mobile_num: null,
            nationality_other: null,
            image:{}
        })
        const imagePreview = ref(null)
        const currStep = ref(1)
        const route = useRoute()
        const IDcardChecking = ref(null)
        const isNotUniqueIDCard = ref(null)
        const rules = {
            title: {
                required: helpers.withMessage(`กรุณาเลือกคำนำหน้าชื่อ`, required)
            },
            name: {
                required: helpers.withMessage(`กรุณากรอกชื่อ`, required)
            },
            surname: {
                required: helpers.withMessage(`กรุณากรอกนามสกุล`, required)
            },
            nationality: {
                required: helpers.withMessage(`กรุณาเลือกสัญชาติ`, required)
            },
            sex: {
                required: helpers.withMessage(`กรุณาเลือกเพศ`, required)
            },
            // is_hh_head: {
            //     required: helpers.withMessage(`กรุณาเลือกการเป็นหัวหน้าครัวเรือน`, required)
            // },
            // is_fam_head: {
            //     required: helpers.withMessage(`กรุณาเลือกการเป็นหัวหน้าครอบครัว`, required)
            // },
            birthdate: {
                required: helpers.withMessage(`กรุณาเลือกวันเกิด`, required)
            },
            religion: {
                required: helpers.withMessage(`กรุณาเลือกศาสนา`, required)
            },
            attend_socact: {
                required: helpers.withMessage(`กรุณาเลือกการเข้าร่วมกลุ่มกิจกรรมของชุมชน`, required)
            },
            edu_level: {
                required: helpers.withMessage(`กรุณาเลือกระดับการศึกษาสูงสุด`, required)
            },
            edu_status: {
                required: helpers.withMessage(`กรุณาเลือกสถานะการศึกษา`, required)
            },
            marital_status: {
                required: helpers.withMessage(`กรุณาเลือกสถานะ`, requiredIf(()=>form.vital_status == 1))
            },
            /*imageFile: {
                required: helpers.withMessage(`กรุณาเลือกรูปภาพประจำตัว`, required)
            },*/
            national_id: {
                required: helpers.withMessage(`กรุณากรอกเลขประจำตัวประชาชน`, requiredIf(() =>form.nationality=='ไทย'))
            },
            // hh_head_relation: {
            //     required: helpers.withMessage(`กรุณาเลือกความเกี่ยวข้องกับหัวหน้าครัวเรือน`, requiredIf(() =>form.is_hh_head==0))
            // },
            // fam_head_relation: {
            //     required: helpers.withMessage(`กรุณาเลือกความเกี่ยวข้องกับหัวหน้าครอบครัว`, requiredIf(() =>form.is_fam_head==0))
            // },
            vital_status: {
                required: helpers.withMessage(`กรุณาเลือกสถานะการมีชีวิต`, required)
            },
            father:{
                title: {
                    required: helpers.withMessage(`กรุณาเลือกคำนำหน้าชื่อ`, required)
                },
                 name: {
                    required: helpers.withMessage(`กรุณากรอกชื่อ`, required)
                },
                surname: {
                    required: helpers.withMessage(`กรุณากรอกนามสกุล`, required)
                },
                nationality: {
                    required: helpers.withMessage(`กรุณาเลือกสัญชาติ`, required)
                },
                vital_status: {
                    required: helpers.withMessage(`กรุณาเลือกสถานะการมีชีวิต`, required)
                },
                /*national_id: {
                    required: helpers.withMessage(`กรุณากรอกเลขประจำตัวประชาชน`, requiredIf(() =>form.father.nationality=='ไทย'))
                },*/
            },
            mother:{
                title: {
                    required: helpers.withMessage(`กรุณาเลือกคำนำหน้าชื่อ`, required)
                },
                 name: {
                    required: helpers.withMessage(`กรุณากรอกชื่อ`, required)
                },
                surname: {
                    required: helpers.withMessage(`กรุณากรอกนามสกุล`, required)
                },
                nationality: {
                    required: helpers.withMessage(`กรุณาเลือกสัญชาติ`, required)
                },
                vital_status: {
                    required: helpers.withMessage(`กรุณาเลือกสถานะการมีชีวิต`, required)
                },
                /*national_id: {
                    required: helpers.withMessage(`กรุณากรอกเลขประจำตัวประชาชน`, requiredIf(() =>form.mother.nationality=='ไทย'))
                    // minLength: helpers.withMessage(`required`, minLength(13))
                },&*/
            }
        }
        const validate = useVuelidate(rules, toRefs(form))
        const store = useStore()
        const token = store.getters["userAuth/getToken"];
        const userId = store.getters["userAuth/getUsername"]
        const dataNext = reactive({ current: null, update_id: null, national_id: null })
        const householdId = route.query.hhid
        const duplicateDataChecked = ref(null)
        const externalData = computed(() => store.state.main.externalData);
const externalSystem = computed(() => store.state.main.externalSystem);
        function uploadImage(e){
            let reader = new FileReader();
            let file = e.target.files
            if(file.length > 0){
                form.tempImage = file[0]
                form.imageFile = file[0]
            }
            else{
                form.imageFile = form.tempImage
            }
            /*validate.value.imageFile.$touch()
            if (validate.value.imageFile.$error) return;*/
            reader.onload = function() {
                imagePreview.value = reader.result
            }
            reader.readAsDataURL(form.imageFile)
        }
        function onlyNumber(){
            form.mobile_num = form.mobile_num.replace(/[^\d]/g, "")
        }
        function getHouseholdById(houseId){
            return new Promise((resolve, reject) => {
                const config = {
                    url: `${process.env.VUE_APP_BASE_API}household/getHouseSurveyById/`,
                    method: 'POST',
                    headers:{
                        Authorization: `Bearer ${token}`,
                        "Content-Type": `application/json; charset=utf-8`,
                    },
                    data: {
                        houseId: houseId
                    }
                };
                axios(config)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
            })
        }
        async function sentAPIMember(methodName, updateId, payload){
            return new Promise((resolve, reject) => {
                const config = {
                    url: `${process.env.VUE_APP_BASE_API}member/${updateId ? updateId : ''}`,
                    method: `${methodName}`,
                    headers:{
                        Authorization: `Bearer ${token}`,
                        "Content-Type": `application/json; charset=utf-8`,
                    },
                    data: payload
                };
                axios(config)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
            })
        }
        async function sentUpdateHouseFam(){
            return new Promise(async (resolve, reject) => {
                try{
                    if(form.is_hh_head){
                        await axios.put(`${process.env.VUE_APP_BASE_API}household/${form.hh_id}`,{update:{hh_head: form.national_id}})
                    }
                    if(form.is_fam_head){
                        await axios.put(`${process.env.VUE_APP_BASE_API}family/${form.fam_id}`,{update:{fam_head: form.national_id}})
                    }
                    resolve("success")
                }
                catch(err){
                    reject(err)
                }
            })
        }
        async function nextStep() {
            // emit('next-step', {current:1,update_id:2});  return;// ผ่านไปซะ ทดสอบ DEP
            // emit('next-step', {current:1,update_id:2}); return; // ทดสอบ DEP (ปิดแล้ว เพื่อให้ส่ง national_id ไป step-3)
            form.birthdate = new Date(form.birthdate)
            form.birthdate.setUTCHours(0,0,0,0)
            validate.value.$touch()
            //also check invalid id card
            if (validate.value.$invalid || checkPersonIDCard.value == false || checkFatherIDCard.value == false || checkMotherIDCard.value == false) {
                return;
            }
            try{
                const results = await getHouseholdById(props.isModal ? props.editData.hh_id : householdId)
                let insertData = {
                    doc:{
                        "hh_id": householdId,
                        "fam_id": route.params.famid,
                        "hnum": results.hnum ? results.hnum : null,
                        "village_code": results.village_code ? results.village_code : null,
                        "village_name": results.village_name ? results.village_name : null,
                        "moo": results.moo ? results.moo : null,
                        "soi": results.soi ? results.soi : null,
                        "road": results.road ? results.road : null,
                        "tumbol_code": results.tumbol_code ? results.tumbol_code : null,
                        "tumbol_name": results.tumbol_name ? results.tumbol_name : null,
                        "amphur_code": results.amphur_code ? results.amphur_code : null,
                        "amphur_name": results.amphur_name ? results.amphur_name : null,
                        "municipality_code": results.municipality_code ? results.municipality_code : null,
                        "municipality_name": results.municipality_name ? results.municipality_name : null,
                        "province_code": results.province_code ? results.province_code : null,
                        "province_name": results.province_name ? results.province_name : null,
                        "postcode": results.postcode ? results.postcode : null,
                        "mso_osm": results.mso_osm ? results.mso_osm : null,
                        "title": form.title,
                        "name": form.name,
                        "surname": form.surname,
                        "national_id": form.nationality ? form.nationality == "ไทย" ? form.national_id : null : null,
                        "mobile_num": form.mobile_num,
                        "birthdate": form.birthdate.toISOString(),
                        "sex": form.sex,
                        "marital_status": form.vital_status ? form.vital_status == 1 ? form.marital_status : null : null,
                        "nationality": form.nationality,
                        "nationality_other": form.nationality_other,
                        "religion": form.religion,
                        // "is_hh_head": form.is_hh_head,
                        // "is_fam_head": form.is_fam_head,
                        "vital_status": form.vital_status,
                        "edu_status": form.edu_status,
                        "edu_level": form.edu_level,
                        "attend_socact": form.attend_socact,
                        "father": form.father,
                        "mother": form.mother,
                        "status" : "created",
                        "created_by": userId,
                        "case_manager": results.case_manager ? results.case_manager : null,
                        "volunteer": results.volunteer ? results.volunteer : null,
                        "msoid": form.national_id ? md5(householdId+form.national_id) : md5(householdId+form.name+form.surname)
                    }
                }
                if(form.csg?.EQ_REGISTER_TYPE === "ผู้ปกครอง"){
insertData.doc.parent = form.parent;
}
if(form.csg){
insertData.doc.csg  = form.csg;
}
                const updateData = {
                    update:{
                        "hh_id": props.isModal ? props.editData.hh_id : results._id,
                        "fam_id": props.isModal ? props.editData.fam_id : route.params.famid,
                        "hnum": results.hnum ? results.hnum : null,
                        "village_code": results.village_code ? results.village_code : null,
                        "village_name": results.village_name ? results.village_name : null,
                        "moo": results.moo ? results.moo : null,
                        "soi": results.soi ? results.soi : null,
                        "road": results.road ? results.road : null,
                        "tumbol_code": results.tumbol_code ? results.tumbol_code : null,
                        "tumbol_name": results.tumbol_name ? results.tumbol_name : null,
                        "amphur_code": results.amphur_code ? results.amphur_code : null,
                        "amphur_name": results.amphur_name ? results.amphur_name : null,
                        "municipality_code": results.municipality_code ? results.municipality_code : null,
                        "municipality_name": results.municipality_name ? results.municipality_name : null,
                        "province_code": results.province_code ? results.province_code : null,
                        "province_name": results.province_name ? results.province_name : null,
                        "postcode": results.postcode ? results.postcode : null,
                        "mso_osm": results.mso_osm ? results.mso_osm : null,
                        "title": form.title,
                        "name": form.name,
                        "surname": form.surname,
                        "national_id": form.nationality ? form.nationality == "ไทย" ? form.national_id : null : null,
                        "mobile_num": form.mobile_num,
                        "birthdate": form.birthdate.toISOString(),
                        "sex": form.sex,
                        "marital_status": form.vital_status ? form.vital_status == 1 ? form.marital_status : null : null,
                        "nationality": form.nationality,
                        "nationality_other": form.nationality_other,
                        "religion": form.religion,
                        // "is_hh_head": form.is_hh_head,
                        // "is_fam_head": form.is_fam_head,
                        "vital_status": form.vital_status,
                        "edu_status": form.edu_status,
                        "edu_level": form.edu_level,
                        "attend_socact": form.attend_socact,
                        "father": form.father,
                        "mother": form.mother,
                        "status" : "modified",
                        "modified_by": store.getters["userInfo/getUserInfoForApi"],
                        "msoid": form.national_id ? md5((props.isModal ? props.editData.hh_id : results._id) + form.national_id) : md5((props.isModal ? props.editData.hh_id : results._id) + form.name+form.surname)
                    }
                }
                
                if(props.isModal){
                    //modal here only update
                    swalCustom.fire({
                        text:"ยืนยันบันทึกข้อมูล",
                        icon:"info",
                        showCancelButton: true,
                        reverseButtons: true,
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก',
                    }).then(async (result) => {
                        if(result.isConfirmed){
                            if(form.imageFile){//มีรูป อัพโหลดรูปก่อนเพื่อให้ได url เพิ่ม key image ก่อนอัพเดทmember
                                const res = await uploadfile(
                                    form.imageFile,
                                    `images/${props.editData.hh_id}`,
                                    `member-image-${props.editData._id}`
                                ).catch(() => {
                                    swalCustom.fire({
                                        icon: "warning",
            text: `บันทึกไฟล์รูปภาพไม่สำเร็จ`,
                                        // text: `บันทึกไฟล์ ${form.imageFile.name} ไม่สำเร็จ`,
                                        confirmButtonText: "ปิด",
                                    })
                         return;
                                });
                                if (res.res.status === 200) {
                                    const image = {
                                        "img_label": "ภาพถ่ายบุคคล",
                                        "file_name": res.file_name,
                                        "img_url": res.url,
                                        "created_date": new Date().toISOString()
                                    }
                                    updateData.update.image = image
                                                        }else if(res.res.response.status === 503){
                        swalCustom.fire({
                                    icon: "warning",
            text: `บันทึกไฟล์รูปภาพไม่สำเร็จ`,
                                    // text: `บันทึกไฟล์ ${form.imageFile.name} ไม่สำเร็จ`,
                                    confirmButtonText: "ปิด",
                                }).then(() => {
                                    const inputElement = document.querySelector('input[type="file"][data-test="image-upload"]');
            if (inputElement) {
                inputElement.value = '';
            }
            this.imagePreview = null; 
        this.form.imageFile = null;
                                   cash('#edit-step1-modal').modal('hide')
                                });
                                return;
                            }
                            }
                            const success = await sentAPIMember("PUT", props.editData._id, updateData)
                            .catch((error) => {
                                swalCustom.fire({
                                    text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                                    icon: "warning",
                                    //timer: 3000, //timeOut for auto-close
                                    confirmButtonText: "ปิด",
                                });
                                console.log(error);
                            });
                            let updateSuccess = await sentUpdateHouseFam().catch((error) => {
                                swalCustom.fire({
                                    text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                                    icon: "warning",
                                    //timer: 3000, //timeOut for auto-close
                                    confirmButtonText: "ปิด",
                                });
                                console.log(error);
                            });
                            if(success && updateSuccess){
                      cash('#edit-step1-modal').modal('hide');
  await new Promise(resolve => setTimeout(resolve, 300));
  Swal.close();
  await swalCustom.fire({
    text:"สำเร็จ",
    icon: 'success',
    timer: 3000,
    confirmButtonText: "ปิด",
    didClose: () => {
      setTimeout(() => {
        emit('update-state');
        console.log('ปัญหาที่ 1');
      }, 100);
    }
  });



//                                  cash('#edit-step1-modal').modal('hide');
//   await new Promise(resolve => setTimeout(resolve, 300));
//    Swal.close();
//   await swalCustom.fire({
//     text:"สำเร็จ",
//     icon: 'success',
//     timer: 3000,
//     confirmButtonText: "ปิด",
//   });
//   emit('update-state');
//   console.log('ปัญหาที่ 1')


            //                     swalCustom.fire({
            //                         text:"สำเร็จ",
            //                         icon: 'success',
            //                         timer: 3000,
            //                         confirmButtonText: "ปิด",
            //                     }).then(() => {
            //   console.log('ปัญหาที่ 1')
            //                        cash('#edit-step1-modal').modal('hide')
            //                       emit('update-state')
            //                     });   
                            }
                        }
                    })
                }
                else{
                    //wizard here
                    try{
                        let updateIdValue, methodName, dataPayload
                        if(props.updateId||form._id){
                            updateIdValue = props.updateId ? props.updateId : form._id
                            methodName = "PUT"
                            dataPayload = updateData
                        }
                        else{
                            updateIdValue = null
                            methodName = "POST"
                            dataPayload = insertData
                        }
                        dataNext['current'] = currStep.value
                        dataNext['national_id'] = form.national_id ?? null
                        const response = await sentAPIMember(methodName, updateIdValue, dataPayload)
                        await sentUpdateHouseFam()
                        if(response.insertedId){
                            dataNext['update_id'] = response.insertedId
                        }
                        if(form.imageFile){
                            const res = await uploadfile(
                                form.imageFile,
                                `images/${householdId}`,
                                `member-image-${response.insertedId ? response.insertedId : updateIdValue}`
                            ).catch(() => {
                                swalCustom.fire({
                                    icon: "warning",
            text: `บันทึกไฟล์รูปภาพไม่สำเร็จ`,
                                    // text: `บันทึกไฟล์ ${form.imageFile.name} ไม่สำเร็จ`,
                                    confirmButtonText: "ปิด",
                                });
                                return;
                            });
                            if (res.res.status === 200) {
                                const image = {
                                    "img_label": "ภาพถ่ายบุคคล",
                                    "file_name": res.file_name,
                                    "img_url": res.url,
                                    "created_date": new Date().toISOString()
                                }
                                const success = await sentAPIMember("PUT", response.insertedId ? response.insertedId : updateIdValue, {"update":{"image":image}})
                                .catch(()=>{
                                    swalCustom.fire({
                                        text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                                        icon: "warning",
                                        // timer: 3000, //timeOut for auto-close
                                        confirmButtonText: "ปิด",
                                    });
                                })
                                 if(success){
                                    form.imageFile = null
                                    emit('next-step', dataNext)
                                }
                            }else if(res.res.response.status === 503){
 swalCustom.fire({
            icon: "warning",
            text: `บันทึกข้อมูลเรียบร้อย แต่บันทึกภาพไม่สำเร็จ`,
            confirmButtonText: "ปิด",
        }).then(() => {const inputElement = document.querySelector('input[type="file"][data-test="image-upload"]');
            if (inputElement) {
                inputElement.value = '';
            }})
            this.imagePreview = null; 
        this.form.imageFile = null;
        router.replace({
                        name: "member-profile",
                        params:{
                mid: response.insertedId ? response.insertedId : updateIdValue
              }
                      });
        return;
      }
                        }
                        else{
                            emit('next-step', dataNext)
                        }
                    }
                    catch(err){
                        console.log("error!", err);
                        swalCustom.fire({
                            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                            icon: "warning",
                            // timer: 3000, //timeOut for auto-close
                            confirmButtonText: "ปิด",
                        });
                    }
                }
            }
            catch(err){
                console.log("error!", err)
                swalCustom.fire({
                    text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                    icon: "warning",
                    // timer: 3000, //timeOut for auto-close
                    confirmButtonText: "ปิด",
                });
            }
        }
        // function skipStep(){
        //     emit('skip-step', currStep.value)

        // }
        function closeWizardForm(){
            emit('close-wizard', currStep.value)
        }
        function inputNumber(){
            if(form.mother.national_id)
                form.mother.national_id = form.mother.national_id.replace(/[^\d]/g, "")
            if(form.father.national_id)
                form.father.national_id = form.father.national_id.replace(/[^\d]/g, "")
        }
        function checkIDCard(value){
            if(value == null){
                return null
            }
            if (value.length == 13 || value.length > 13) {
                var sum, i;
                if (value.substring(0, 1) == 0) return false;
                for (i = 0, sum = 0; i < 12; i++)
                    sum += parseFloat(value.charAt(i)) * (13 - i);
                if ((11 - (sum % 11)) % 10 != parseFloat(value.charAt(12))){
                    return false;
                }
                return true;
            } else if (value.length > 0 ) {
                return false;
            }else {
                return null;
            }
        }
        async function checkExistIdcard(){
            if(checkPersonIDCard.value == false)
                isNotUniqueIDCard.value = null
            else if(form.old_national_id == form.national_id)
                isNotUniqueIDCard.value = null
            else if(form.national_id.length == 13 && checkPersonIDCard.value){
                IDcardChecking.value = true
                isNotUniqueIDCard.value = null
                const result = await checkDuplicateIdcard(form.national_id)
                if(result){
                    IDcardChecking.value = false
                    //in case edit current id not check duplicate
                    if(props.editData?.national_id == result.national_id){
                        isNotUniqueIDCard.value = true
                        duplicateDataChecked.value = null
                    }else{
                        duplicateDataChecked.value = result
                        isNotUniqueIDCard.value = false
                    }
                    // if((props.isModal ? props.editData.hh_id : householdId == result.hh_id) && result.fam_id == null){
                    //     isNotUniqueIDCard.value = true
                    // }
                    // else{
                        // isNotUniqueIDCard.value = false
                    // }
                }
                else{
                    IDcardChecking.value = false
                    isNotUniqueIDCard.value = true
                    duplicateDataChecked.value = null
                }
            }
        }
        const checkPersonIDCard = computed({
            get() {
                return checkIDCard(form.national_id)
            }
        })
        const checkFatherIDCard = computed({
            get() {
                return checkIDCard(form.father.national_id)
            }
        })
        const checkMotherIDCard = computed({
            get() {
                return checkIDCard(form.mother.national_id)
            }
        })
        watch(()=>form.national_id,()=>{
            if(form.national_id > 13){
                form.national_id = form.national_id.slice(0, 13);
            }
        })
        watch(()=>form.mother.national_id,()=>{
            if(form.mother.national_id > 13){
                form.mother.national_id = form.mother.national_id.slice(0, 13);
            }
        })
        watch(()=>form.father.national_id,()=>{
            if(form.father.national_id > 13){
                form.father.national_id = form.father.national_id.slice(0, 13);
            }
        })
        watch(()=>props.formSearch,()=>{
            const data = JSON.parse(JSON.stringify(props.formSearch))
            Object.assign(form, data)
            form.nationality = data.nationality ? data.nationality : data.national_id ? "ไทย" : null
            form.attend_socact = data.attend_socact?data.attend_socact:[]
            form.father = data.father ? data.father : {}
            form.mother = data.mother ? data.mother : {}
            form.old_national_id = data.national_id
            imagePreview.value = data.image ? data.image.img_url : null
        })
        watch(()=> props.cancelModal,(val)=>{
            if(val){
                Object.assign(form, formDefault)
                validate.value.$reset()
            }
        })
        watch(()=> props.openModal,(val)=>{
            if(val){
                const dataEdit = JSON.parse(JSON.stringify(props.editData))
                form.title = dataEdit.title ? dataEdit.title : null
                form.name = dataEdit.name ? dataEdit.name : null
                form.surname = dataEdit.surname ? dataEdit.surname : null
                form.national_id = dataEdit.national_id ? dataEdit.national_id : null
                form.mobile_num = dataEdit.mobile_num ? dataEdit.mobile_num : null
                form.birthdate = dataEdit.birthdate ? dataEdit.birthdate : null,
                form.sex = dataEdit.sex ? dataEdit.sex : null
                form.marital_status = dataEdit.marital_status ? dataEdit.marital_status : null
                form.nationality = dataEdit.national_id ? "ไทย" : dataEdit.nationality ? dataEdit.nationality : null
                form.nationality_other = dataEdit.nationality_other ? dataEdit.nationality_other : null
                form.religion = dataEdit.religion ? dataEdit.religion : null
                form.vital_status = (dataEdit.vital_status === 1 || dataEdit.vital_status === 0) ? dataEdit.vital_status : null
                form.edu_status = dataEdit.edu_status ? dataEdit.edu_status : null
                form.edu_level = dataEdit.edu_level ? dataEdit.edu_level : null
                form.attend_socact = dataEdit.attend_socact?dataEdit.attend_socact:[]
                form.father = dataEdit.father ? dataEdit.father : {}
                form.mother = dataEdit.mother ? dataEdit.mother : {}
                imagePreview.value = dataEdit.image ? dataEdit.image.img_url : null
                form.is_hh_head = dataEdit.is_hh_head ? dataEdit.is_hh_head : null
                form.is_fam_head = dataEdit.is_fam_head ? dataEdit.is_fam_head : null
                form.hh_id = dataEdit.hh_id ? dataEdit.hh_id : null
                form.fam_id = dataEdit.fam_id ? dataEdit.fam_id : null
            }
        })
        watch(externalData, (newData) => {
            console.log(externalSystem.value)
  if (newData) {
    console.log('ได้รับข้อมูลใหม่:', newData);
    fillFormWithConnectionData(newData);
  }
});const formatBoraDateofBirth = (dateofbirth) => {
  if (!dateofbirth || String(dateofbirth).trim() === '') return '';
  const s = String(dateofbirth).trim();
  if (s.length !== 8) return '';
  const yearBE = parseInt(s.slice(0, 4), 10);
  const month = s.slice(4, 6);
  const day = s.slice(6, 8);
  const yearCE = yearBE - 543;
  const monthNum = parseInt(month, 10);
  const dayNum = parseInt(day, 10);
  if (monthNum < 1 || monthNum > 12 || dayNum < 1 || dayNum > 31) return '';
  const date = new Date(Date.UTC(yearCE, monthNum - 1, dayNum, 0, 0, 0, 0));
  if (isNaN(date.getTime())) return '';
  return date.toISOString();
};
// แยกชื่อเต็มเป็น name กับ surname (คำสุดท้าย = นามสกุล) ใช้กับ fathername / mothername จาก BORA
const splitFullName = (full) => {
  if (!full || String(full).trim() === '') return { name: '', surname: '' };
  const parts = String(full).trim().split(/\s+/);
  if (parts.length === 1) return { name: parts[0], surname: '' };
  const surname = parts.pop();
  const name = parts.join(' ');
  return { name, surname };
};
const fillFormWithConnectionData = (data) => {
    console.log('กำลังเติมข้อมูล:', data);
    if(data.bora){
        console.log('BORA')
        console.log(data)
try {
        // ใช้รูปแบบ mapping เดียวกับ CompareDataBORA (GenerateOtherSystemConnection.vue 542–580)
        // data ที่ได้มาคือข้อมูลดิบจาก BORA: pid, firstname, lastname, gender, dateofbirth, personstatus, fathername ฯลฯ
        if (data.title)     form.title       = data.title;
        if (data.firstname) form.name        = data.firstname;
        if (data.lastname)  form.surname     = data.lastname;
        if (data.pid)       form.national_id = data.pid;

        if (data.gender) {
            const g = data.gender;
            form.sex =
                g === "1" || String(g).includes("ชาย")
                    ? "ชาย"
                    : g === "2" || String(g).includes("หญิง")
                        ? "หญิง"
                        : (g || '');
        }
        if (data.nationality)  form.nationality  = data.nationality;
        // if (data.personstatus) form.vital_status = data.personstatus === "ปกติ" ? 1 : 0;
        if (data.dateofbirth) {
            const isoBirth = formatBoraDateofBirth(data.dateofbirth);
            if (isoBirth) form.birthdate = isoBirth;
        }
        // บิดา
        if (data.fathername || data.fatherpid || data.fathernationality) {
            const fatherSplit = splitFullName(data.fathername);
            if (!form.father) form.father = {};
            if (data.fatherpid)         form.father.national_id = data.fatherpid;
            if (fatherSplit.name)       form.father.name        = fatherSplit.name;
            if (fatherSplit.surname)    form.father.surname     = fatherSplit.surname;
            if (data.fathernationality) form.father.nationality = data.fathernationality;
        }
        // มารดา
        if (data.mothername || data.motherpid || data.mothernationality) {
            const motherSplit = splitFullName(data.mothername);
            if (!form.mother) form.mother = {};
            if (data.motherpid)         form.mother.national_id = data.motherpid;
            if (motherSplit.name)       form.mother.name        = motherSplit.name;
            if (motherSplit.surname)    form.mother.surname     = motherSplit.surname;
            if (data.mothernationality) form.mother.nationality = data.mothernationality;
        }
        // if (data.moo) form.moo = data.moo;
        // if (data.postcode) form.postcode = data.postcode;
        // if (data.province_code) form.province_code = data.province_code;
        // if (data.province_name) form.province_name = data.province_name;
        // if (data.road) form.road = data.road;
        // if (data.soi) form.soi = data.soi;
        // if (data.hnum) form.hnum = data.hnum;
        // if (data.amphur_code) form.amphur_code = data.amphur_code;
        // if (data.amphur_name) form.amphur_name = data.amphur_name;
        // if (data.tumbol_code) form.tumbol_code = data.tumbol_code;
        // if (data.tumbol_name) form.tumbol_name = data.tumbol_name;
        // if (data.village_code) form.village_code = data.village_code;
        // if (data.village_name) form.village_name = data.village_name;
    } catch (error) {
        console.error('Error filling form with data:', error);
        swalCustom.fire({
            title: 'เกิดข้อผิดพลาด',
            text: 'ไม่สามารถเติมข้อมูลได้ กรุณาลองอีกครั้ง',
            icon: 'error',
            confirmButtonText: 'ตกลง'
        });
    }
    }else if(data.EQC_FIRSTNAME){
try {
        // ข้อมูลทั่วไปของเด็ก
        if (data.EQC_CODE_PRENAME) form.title = data.EQC_CODE_PRENAME.replace('น.ส.','นางสาว');
        if (data.EQC_FIRSTNAME) form.name = data.EQC_FIRSTNAME;
        if (data.EQC_LASTNAME) form.surname = data.EQC_LASTNAME;
        
        if (data.EQC_BIRTH_DATE) {
            form.birthdate = new Date(convertThaiDateToISO(data.EQC_BIRTH_DATE));
        }
        
        if (data.EQ_CODE_FATHER_PRENAME) {
            form.father.title = data.EQ_CODE_FATHER_PRENAME;
        }
        if (data.EQ_FATHER_NAME) {
            form.father.name =data.EQ_FATHER_NAME;
        }
        if (data.EQ_FATHER_LNAME) {
            form.father.surname = data.EQ_FATHER_LNAME;
        }
        if (data.EQ_FATHER_IDCARD) {
            form.father.national_id = data.EQ_FATHER_IDCARD.toString().replace(/[^\d]/g, "");
        }
        if (data.EQ_FATHER_NATIONALITY) {
            form.father.nationality = (data.EQ_FATHER_NATIONALITY).replace('สัญชาติ','') === "ไทย" ? "ไทย" : "อื่นๆ";
            if (form.father.nationality === 'อื่นๆ' && data.EQ_FATHER_NATIONALITY_OTHER) {
                form.father.nationality_other = data.EQ_FATHER_NATIONALITY_OTHER;
            }
        }
        if (data.EQ_FATHER_VITAL_STATUS !== undefined) {
            form.father.vital_status = data.EQ_FATHER_VITAL_STATUS;
        }
        
        if (data.EQ_CODE_MOTHER_PRENAME) {
            form.mother.title = data.EQ_CODE_MOTHER_PRENAME.replace('น.ส.','นางสาว');
        }
        if (data.EQ_MOTHER_NAME) {
            form.mother.name = data.EQ_MOTHER_NAME;
        }
        if (data.EQ_MOTHER_LNAME) {
            form.mother.surname = data.EQ_MOTHER_LNAME;
        }
        if (data.EQ_MOTHER_IDCARD) {
            form.mother.national_id = data.EQ_MOTHER_IDCARD.toString().replace(/[^\d]/g, "");
        }
        if (data.EQ_MOTHER_NATIONALITY) {
            form.mother.nationality = (data.EQ_MOTHER_NATIONALITY).replace('สัญชาติ','') === "ไทย" ? "ไทย" : "อื่นๆ";
            if (form.mother.nationality === 'อื่นๆ' && data.EQ_MOTHER_NATIONALITY_OTHER) {
                form.mother.nationality_other = data.EQ_MOTHER_NATIONALITY_OTHER;
            }
        }
        if (data.EQ_MOTHER_VITAL_STATUS !== undefined) {
            form.mother.vital_status = data.EQ_MOTHER_VITAL_STATUS;
        }
        
        if (data.EQC_NATIONALITY) {
            form.nationality = (data.EQC_NATIONALITY).replace('สัญชาติ','') === "ไทย" ? "ไทย" : "อื่นๆ";
        }
        if (data.EQC_NATIONAL_ID) {
            form.national_id = data.EQC_NATIONAL_ID.toString().replace(/[^\d]/g, "");
        }
        if (data.EQC_SEX) {
            form.sex = data.EQC_SEX;
        }
        if (data.EQC_RELIGION) {
            form.religion = data.EQC_RELIGION;
        }
        if (data.EQC_MOBILE_NUM) {
            form.mobile_num = data.EQC_MOBILE_NUM.toString().replace(/[^\d]/g, "");
        }
if(data?.EQ_REGISTER_TYPE === "ผู้ปกครอง"){
let updates_parent = {
national_id: data.EQ_IDCARD || '',
title: (data.EQ_CODE_PRENAME || '').replace('น.ส.','นางสาว'),
name: data.EQ_FIRSTNAME || '',
surname: data.EQ_LASTNAME || '',
nationality: (data.EQ_NATIONALITY || '').replace('สัญชาติ',''),
birthdate: data.EQ_BIRTHDAY || ''
};
form.parent=updates_parent
}
form.csg = {};
form.csg.register_status = data.STATUS || null;
form.csg.status = data.csg_status || null;
form.csg.registrant_type= data.EQ_REGISTER_TYPE || null;
        // สั่งให้ Vuelidate ตรวจสอบความถูกต้องใหม่
        // validate.value.$touch();
        
        // swalCustom.fire({
        //     title: 'เติมข้อมูลสำเร็จ',
        //     text: 'ระบบได้เติมข้อมูลในฟอร์มแล้ว',
        //     icon: 'success',
        //     confirmButtonText: "ปิด",
        //     timer: 3000
        // });
        
    } catch (error) {
        console.error('Error filling form with data:', error);
        swalCustom.fire({
            title: 'เกิดข้อผิดพลาด',
            text: 'ไม่สามารถเติมข้อมูลได้ กรุณาลองอีกครั้ง',
            icon: 'error',
            confirmButtonText: 'ตกลง'
        });
    }
    }else{
        return;
    }
    
};
        function cancelModalButton(){
            validate.value.$reset()
            emit('cancelButton')
        }
        return {
            form,
            dataJson,
            uploadImage,
            imagePreview,
            formOption,
            onlyNumber,
            nextStep,
            // skipStep,
            closeWizardForm,
            validate,
            inputNumber,
            checkPersonIDCard,
            checkFatherIDCard,
            checkMotherIDCard,
            monthYear,
            format,
            checkExistIdcard,
            IDcardChecking,
            isNotUniqueIDCard,
            cancelModalButton,
            duplicateDataChecked
        }
    }
})
</script>

<style lang="scss" scoped>
.image-upload{
    width: 100px;
    height: 120px;
    position: relative;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    .image-file{
        position: absolute;
        height: 100%;
        width: 100%;
        left: 0;
        opacity: 0;
        z-index: 2;
        cursor: pointer;
    }
    .icon-img{
        margin:18px auto;
        z-index: -1;
    }
    .preview-image{
        z-index: 1;
        border: 2px dashed #d9d9d9;
        img{
            object-fit: cover;
            height: 100%;
            object-position: center;
        }
    }
}
</style>
<style lang="scss">
</style>